// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"9808afda","52":"e82bb577","76":"6d9e0a40","247":"04819e09","261":"3477033f","298":"3461630d","407":"fc7d2524","518":"21a65aaf","631":"b52deee6","643":"03be2b04","671":"6880b340","878":"a4eabf5e","903":"f5673ec6","995":"47507c68"}[chunkId] + ".chunk.js";
};